module.exports = __webpack_public_path__ + "static/img/useradmin_bg.58c6da5d.jpg";